/**
 * Séparation Entrea (app métier / projet) vs Console Uruganda (plateforme, org, SaaS).
 * Par défaut l’UI SaaS n’est pas embarquée dans Entrea — tout passe par la console.
 */

export const ADMIN_CONSOLE_URL = (process.env.REACT_APP_ADMIN_CONSOLE_URL || '').replace(/\/$/, '');

/** À true uniquement pour un mode développement / démo avec écrans SaaS dans Entrea */
export const ENABLE_EMBEDDED_SAAS_UI = process.env.REACT_APP_ENABLE_ENTREA_SAAS_UI === 'true';

export function adminConsoleUrl(path = '') {
  if (!ADMIN_CONSOLE_URL) return '';
  if (!path) return ADMIN_CONSOLE_URL;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${ADMIN_CONSOLE_URL}${p}`;
}
